import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions } from "@tanstack/react-query";

import { usePaginateQuery } from "@/hooks";
import { adminApi } from "@/lib/api";
import { type Paginate, type SearchRequest } from "@/types";

import { type AdminTransaction } from "@/modules/recognition/admin/types";

type TransactionList = Paginate<AdminTransaction<true, true, true>>;

export const transactions = createQueryKeys("admin-recognition-transactions", {
  all: (page?: number, filter?: SearchRequest) => [{ page, filter }],
});

const include = "to_user.{position},value,attributes";

export const fetchTransactionsQueryOptions = (
  page: number = 0,
  search?: SearchRequest,
) =>
  queryOptions({
    ...transactions.all(page, search),
    queryFn: () =>
      adminApi
        .get<TransactionList>(`/recognition/transactions?include=${include}`, {
          params: { page, ...search },
        })
        .then((response) => response.data),
  });

export const useFetchTransactions = (search?: SearchRequest) =>
  usePaginateQuery((page) => fetchTransactionsQueryOptions(page, search));
